<template>
  <el-select
    v-model="value"
    :multiple="true"
    filterable
    remote
    reserve-keyword
    placeholder="Enter 3 or more characters"
    no-data-text="Could not find and refs matching your query"
    no-match-text="Could not find any refs for your query"
    loading-text="Loading..."
    :remote-method="lookup"
    :loading="loading"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item"
      :label="item"
      :value="item"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { useMarketplaceStore } from '@/apps/traforama/store/marketplace'

export default defineComponent({
  name: 'RefHostSelect',
  props: {
    modelValue: {
      required: true,
      type: Array
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const marketplaceStore = useMarketplaceStore()
    const loading = ref(false)
    const options = ref<string[]>([])

    const lookup = async (query: string) => {
      if (query.length >= 3) {
        loading.value = true
        options.value = await marketplaceStore.SearchRefHosts(query)
        loading.value = false
      }
    }

    const update = function (newValue: any) {
      context.emit(
        'update:modelValue',
        newValue.map((x: any) => String(x))
      )
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { loading, lookup, options, update, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
